export interface IConfigurationPluginOptions {
  tenant: string;
}

export class ConfigurationPlugin {
  public static configuration: NodeJS.ProcessEnv;
  private currentConfiguration: string;
  private env: any;

  constructor(options: IConfigurationPluginOptions) {
    this.currentConfiguration = options.tenant;
    this.env = {};
    this.setConfiguration(this.currentConfiguration);
  }

  public getConfiguration() {
    return this.currentConfiguration;
  }

  public setConfiguration(tenant: string) {
    tenant = tenant.toUpperCase();
    this.env = ConfigurationPlugin.configuration[tenant];
    this.currentConfiguration = tenant;
  }
}

ConfigurationPlugin.configuration = process.env;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/plugins/configuration/configuration.ts